var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.11 11.1371C8.5525 9.43215 4.38167 9.43215 1.80583 11.1371C0.641667 11.9163 0 12.9705 0 14.098C0 15.2255 0.641667 16.2705 1.79667 17.0405C3.08 17.9021 4.76667 18.333 6.45333 18.333C8.14 18.333 9.82667 17.9021 11.11 17.0405C12.265 16.2613 12.9067 15.2163 12.9067 14.0796C12.8975 12.9521 12.265 11.9071 11.11 11.1371Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5272 4.89509C16.6739 6.67343 15.4089 8.23176 13.658 8.44259C13.6489 8.44259 13.6489 8.44259 13.6397 8.44259H13.6122C13.5572 8.44259 13.5022 8.44259 13.4564 8.46092C12.5672 8.50676 11.7514 8.22259 11.1372 7.70009C12.0814 6.85676 12.6222 5.59176 12.5122 4.21676C12.448 3.47426 12.1914 2.79592 11.8064 2.21842C12.1547 2.04426 12.558 1.93426 12.9705 1.89759C14.7672 1.74176 16.3714 3.08009 16.5272 4.89509Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3607 13.374C18.2873 14.2632 17.719 15.0332 16.7657 15.5557C15.849 16.0599 14.694 16.2982 13.5482 16.2707C14.2082 15.6749 14.5932 14.9324 14.6665 14.144C14.7582 13.0074 14.2173 11.9165 13.1357 11.0457C12.5215 10.5599 11.8065 10.1749 11.0273 9.89071C13.0532 9.30404 15.6015 9.69821 17.169 10.9632C18.0123 11.6415 18.4432 12.494 18.3607 13.374Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45329 0C4.05162 0 2.09912 1.9525 2.09912 4.35417C2.09912 6.71 3.94162 8.61667 6.34329 8.69917C6.41662 8.69 6.48995 8.69 6.54496 8.69917C6.56329 8.69917 6.57245 8.69917 6.59079 8.69917C6.59995 8.69917 6.59996 8.69917 6.60912 8.69917C8.95579 8.61667 10.7983 6.71 10.8075 4.35417C10.8075 1.9525 8.85495 0 6.45329 0Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.3fbd62ad3cf73e21ce80b459dbed6a66.svg";
export { ForwardRef as ReactComponent };